// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "cdf0ebbcbb7fc8f6f1b4" + ".chunk.js";
};